<template>
<div class="page tableofcontents" v-if="portfolio.impact_report">
  <p class="preheader">
    Appendix
  </p>
  <p class="dustin-title ">
    Additional Disclaimers
  </p>
  <p class="preheader">
    Scope
  </p>
  <div class="content description">
    <p>
    Data in this report pertain only to social impact, not financial performance. Stake PBC is not an investment advisor, and does not provide investment advice or investment recommendations. Investing involves risk. Depending on the types of investments, there may be varying degrees of risk. Socially responsible investing does not guarantee any amount of success.
    The information contained herein is believed to be from reliable sources, but we make no warranty or guarantee as to the accuracy of the information. Information provided is as of {{ new Date().toLocaleDateString('en-US', {timeZone: 'UTC'}) }} and may change over time based on market or other conditions without notice.
    Please consult with your advisor for more details about any of the metrics displayed in this report.
    </p>
    <p>
      Investing involves risk. Depending on the types of investments, there may be varying degrees of risk. Socially responsible investing does not guarantee any amount of success. This analysis may not provide a complete picture of the social impact as it is only as reliable as the amount of data available.
    </p>
  <p class="preheader">
    Links
  </p>
  <p class="description">
      Links to external websites are strictly as a courtesy. We make no representation as to the completeness or accuracy of information provided in the web links within this report. Nor is Stake liable for any direct or indirect technical or system issues or any consequences arising out of your access to or your use of third-party technologies, web sites, information and programs made available through this report. When you access one of these links, you assume total responsibility and risk for your use of the web sites.
  </p>
  <p v-if="portfolio.impact_report.firm.compliance_language" class="preheader">
    Firm Disclosures
  </p>
  <div v-if="portfolio.impact_report.firm.compliance_language" class="compliance-block">
    <p v-html="this.split_compliance_language"></p>
  </div>

  </div>
  <!-- space for custom disclaimers -->
</div>
</template>


<script>

  export default {
    components: {
    },
    data () {
      return {
        datacollection: {}
      }
    },
    props: {
      portfolio: Object,
    },
    computed: {
      split_compliance_language: function() {
        return this.portfolio.impact_report.firm.compliance_language.replace(new RegExp('\r?\n','g'), '<br />');
      }
    },
    mounted () {
    },
  }

</script>

<style lang="css" scoped>
  .compliance-block {
      white-space: pre-line; // or pre-line
  }
  .persona_vegan .icon {
    color: #5aa9e6;
  }
  .persona_environmentalist .icon {
    color: #93C48B;
  }
  .persona_racial_justice .icon {
    color: #685369;
  }
  .persona_feminist .icon {
    color: #f1ab86;
  }
  .persona_virtuous .icon {
    color: #78CAD2;
  }
  .persona_labor .icon {
    color: #A40E4C;
  }
  .persona_law_and_order .icon {
    color: #8499B1;
  }

  .additional-notes {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }

  .additional-notes label, #notes-input {
    display: block;
    width: 75%;
    margin: 0 auto;
  }

  #notes-input {
    background-color: #fff;
    padding: 5px;
    height: 150px;
    margin: 15px auto;
    border: 2px solid lightgray;
  }

  .actions {
    text-align: center;
    margin: 0 auto;
  }

  .actions > a {
    display: block;
    margin-top: 20px;
  }

.moreshow {
  /* display: none */
}

</style>
